export default "__VITE_ASSET__D8AQXk_g__";